/* Cart quantities use stable line identity and share one write with wrapping. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else { root.GBCartQuantity = api; api.install(root, root.document); }
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';
  function canonical(value) {
    if (Array.isArray(value)) value = Object.fromEntries(value.filter(function (entry) { return Array.isArray(entry) && entry.length === 2; }));
    var object = value || {};
    return JSON.stringify(Object.keys(object).sort().map(function (key) { return [key, object[key]]; }));
  }
  function identity(line) {
    return String(line.variantId || line.variant_id) + '|' + String(line.sellingPlanId || (line.selling_plan_allocation && line.selling_plan_allocation.selling_plan.id) || '') + '|' + canonical(line.properties);
  }
  function locate(lines, previous) {
    var exact = lines.find(function (line) { return line.key === previous.key && identity(line) === identity(previous); });
    if (exact) return exact;
    var matches = lines.filter(function (line) { return identity(line) === identity(previous); });
    return matches.length === 1 ? matches[0] : null;
  }
  function wrapping(line, state) { return line.handle === 'giftwrap' || String(line.productId || line.product_id) === String(state.wrap && state.wrap.productId); }
  function plan(state, previous, quantity, core, rate) {
    if (!Number.isInteger(quantity) || quantity < 0) throw new Error('Enter a whole quantity of zero or more.');
    var current = locate(state.lines || [], previous);
    if (!current) return { missing: true, noop: quantity === 0, quantity: quantity };
    var proposed = state.lines.map(function (line) { return line === current ? Object.assign({}, line, { quantity: quantity }) : line; }).filter(function (line) { return line.quantity > 0; });
    var units = core.countBlasterUnits(proposed), attrs = state.attributes || {};
    var wrapLines = state.lines.filter(function (line) { return wrapping(line, state); });
    var choice = attrs.gb_wrap_choice === 'off' || (!wrapLines.length && Number(attrs.gb_wrap_last_units || 0) > 0) ? 'off' : 'on';
    var quote = core.quoteGiftwrap(units, { defaultId: state.wrap && state.wrap.defaultVariantId, tiers: state.wrap && state.wrap.variants || {} }, rate);
    var rule = current.quantityRule || {};
    // update.js does not enforce stocked-variant inventory. Only the store's
    // explicitly unlimited, unrestricted one-time variants use the batch path.
    var batch = current.inventoryPolicy === 'continue' && !current.sellingPlanId && !Object.keys(current.properties || {}).length
      && Number(rule.min || 1) === 1 && Number(rule.increment || 1) === 1 && rule.max == null
      && (choice === 'off' || quote.status === 'ready' || quote.status === 'none');
    if (!batch) return { key: current.key, quantity: quantity, mode: 'change', noop: Number(current.quantity) === quantity };
    var gift = core.reconcileAddonLines({ lines: proposed.filter(function (line) { return wrapping(line, state); }), wrap: quote, wrapChoice: choice, protectionChoice: 'off', wrapProductIds: [state.wrap && state.wrap.productId] });
    var updates = {}, changedAttrs = {};
    if (Number(current.quantity) !== quantity) updates[current.key] = quantity;
    Object.keys(gift.updates).forEach(function (key) { updates[key.replace(/^variant:/, '')] = gift.updates[key]; });
    if (String(attrs.gb_wrap_last_units) !== String(units)) changedAttrs.gb_wrap_last_units = String(units);
    if (attrs.gb_wrap_choice !== choice) changedAttrs.gb_wrap_choice = choice;
    return { key: current.key, quantity: quantity, mode: 'update', updates: updates, attributes: changedAttrs, units: units,
      wrapChoice: choice, wrapVariant: choice === 'on' && quote.status === 'ready' ? String(quote.variantId) : null,
      noop: !Object.keys(updates).length && !Object.keys(changedAttrs).length };
  }
  function install(window, document) {
    if (!document || window.__gbCartQuantityInstalled) return;
    var installed = false, jobs = new Map(), dispatches = new WeakMap(), spinnerPointers = new WeakMap(), latest = new Map(), nativeUpdate;
    function trace(type, data) { if (window.GBCartDiagnostics) window.GBCartDiagnostics.record(type, data); }
    function parse(scope) {
      try { return JSON.parse(scope.querySelector('[data-gb-cart-state] [data-gb-addon-state]').textContent); } catch (error) { return null; }
    }
    function rowLine(component, index, target) {
      var scope = target && target.closest && target.closest('#CartDrawer-CartItems') || component;
      var state = parse(scope);
      return state && state.lines[Number(index) - 1];
    }
    function errorMessage(message) {
      var node = document.getElementById('CartDrawer-CartErrors');
      if (node && node.textContent !== (message || '')) node.textContent = message || '';
    }
    function paintPending() {
      var component = document.querySelector('cart-drawer-items'), state = component && parse(component);
      if (!state) return;
      state.lines.forEach(function (line, index) {
        var row = component.querySelector('#CartDrawer-Item-' + (index + 1)), job = jobs.get(identity(line));
        if (!row) return;
        if (row.getAttribute('aria-busy') !== String(!!job)) row.setAttribute('aria-busy', String(!!job));
        row.querySelectorAll('.loading-overlay').forEach(function (spinner) {
          if (spinner.classList.contains('hidden') !== !job) spinner.classList.toggle('hidden', !job);
          // The native full-row overlay must not swallow a newer quantity click.
          if (job) {
            if (!spinnerPointers.has(spinner)) spinnerPointers.set(spinner, spinner.style.pointerEvents);
            if (spinner.style.pointerEvents !== 'none') spinner.style.pointerEvents = 'none';
          } else if (spinnerPointers.has(spinner)) {
            spinner.style.pointerEvents = spinnerPointers.get(spinner); spinnerPointers.delete(spinner);
          }
        });
        var input = row.querySelector('.quantity__input');
        var value = String(job && job.quantity > 0 ? job.quantity : line.quantity);
        if (input && input.value !== value) input.value = value;
      });
    }
    function preservedSections(sections) {
      var drawer = document.querySelector('cart-drawer');
      if (!sections || !sections['cart-drawer'] || typeof window.fixParsedHtml !== 'function' || !drawer || !drawer.querySelector('cart-drawer-upsell, cart-drawer-gift')) return sections;
      var parsed = new window.DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var inner = parsed.querySelector('.drawer__inner');
      if (inner) { window.fixParsedHtml(drawer, inner); sections['cart-drawer'] = parsed.body.innerHTML; }
      return sections;
    }
    function request(component, index, quantity, name, context, stamp) {
      var previous = context || rowLine(component, index);
      if (!previous) return null;
      if (typeof quantity === 'string' && quantity.trim() === '') {
        errorMessage('Enter a whole quantity of zero or more.'); paintPending(); return Promise.resolve(false);
      }
      quantity = Number(quantity); stamp = Number(stamp || window.performance.now());
      if (stamp > 1e12) stamp -= window.performance.timeOrigin;
      var key = identity(previous);
      if (stamp < (latest.get(key) || 0)) { trace('native-stale-drop', { variantId: previous.variantId }); return Promise.resolve(true); }
      latest.set(key, stamp);
      var existing = jobs.get(key);
      if (existing) {
        if (existing.quantity !== quantity) { existing.quantity = quantity; existing.version += 1; paintPending(); }
        return existing.promise;
      }
      var job = { previous: previous, quantity: quantity, name: name, version: 1, promise: null };
      jobs.set(key, job); paintPending(); errorMessage('');
      var cartApi = window.GBCart, core = window.GBAddonPricingCore;
      job.promise = cartApi.queueMutation(async function () {
        while (true) {
          var version = job.version, wanted = job.quantity;
          try {
            var live = document.querySelector('cart-drawer-items');
            var state = cartApi.addonState() || parse(live);
            if (!state) throw new Error('Cart details are unavailable. Please try again.');
            var currentLine = locate(state.lines, previous);
            if (document.querySelector('cart-drawer-gift, .quantity-gifts, quantity-break-upsells')) {
              // Keep native conditional-gift behavior intact on specialized
              // offer pages. Their quantity request still joins the same queue.
              if (!currentLine) { if (wanted === 0) return true; throw new Error('This cart item changed. Please try again.'); }
              trace('native-compatible-mode', { reason: 'conditional-gift-widget', variantId: previous.variantId });
              await nativeUpdate.call(live, state.lines.indexOf(currentLine) + 1, wanted, name);
              if (version !== job.version) continue;
              var verifiedCart = await cartApi.readCart();
              var verifiedLine = locate(verifiedCart.items || [], previous);
              return (verifiedLine ? Number(verifiedLine.quantity) : 0) === wanted;
            }
            var rate = core.positiveRate(state.rate) || core.positiveRate(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
            var next = plan(state, previous, wanted, core, rate);
            if (next.missing && !next.noop) throw new Error('This cart item changed. Please try again.');
            if (!next.noop) {
              var body = { sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname };
              var url = '/cart/change.js?kaching_bundles=true';
              if (next.mode === 'update') { body.updates = next.updates; body.attributes = next.attributes; url = '/cart/update.js?kaching_bundles=true'; }
              else { body.id = next.key; body.quantity = wanted; }
              trace('native-stable-write', { variantId: previous.variantId, quantity: wanted, mode: next.mode, wrapVariant: next.wrapVariant });
              var response = await window.fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
              var data = await response.json();
              if (!response.ok || data.errors || !Array.isArray(data.items)) throw new Error(data.description || data.errors || 'Cart update failed (' + response.status + ').');
              if (!cartApi.applyDrawer(preservedSections(data.sections))) throw new Error('The cart view could not refresh.');
              cartApi.commitCart(data, true); paintPending();
              var actual = locate(data.items, previous);
              if ((actual ? Number(actual.quantity) : 0) !== wanted) throw new Error('The quantity update was not confirmed.');
              if (next.mode === 'update') {
                var wraps = data.items.filter(function (line) { return wrapping(line, state); });
                if (next.wrapVariant ? wraps.length !== 1 || String(wraps[0].variant_id) !== next.wrapVariant || wraps[0].quantity !== 1 : wraps.length !== 0) throw new Error('The wrapping update was not confirmed.');
                if (Object.keys(next.attributes).some(function (key) { return (data.attributes || {})[key] !== next.attributes[key]; })) throw new Error('The cart options were not confirmed.');
              }
              if (typeof window.publish === 'function') window.publish('cart-update', { source: 'cart-items', cartData: data });
              document.dispatchEvent(new window.CustomEvent('cartQuantityUpdated', { detail: { handle: 'handle' } }));
              if (typeof window.validateCartGifts === 'function') window.validateCartGifts(false);
            }
            if (version !== job.version) continue;
            errorMessage(''); return true;
          } catch (error) {
            try { await cartApi.readCart(true); } catch (readError) {}
            if (version !== job.version) continue;
            errorMessage(error.message || 'Could not update your cart. Please try again.');
            trace('native-stable-error', { message: error.message }); return false;
          }
        }
      }).finally(function () { jobs.delete(key); paintPending(); });
      return job.promise;
    }
    function ready() {
      var ctor = window.customElements && window.customElements.get('cart-drawer-items');
      if (installed || !ctor || !window.GBCart || !window.GBCart.queueMutation || !window.GBAddonPricingCore) return;
      installed = true; window.__gbCartQuantityInstalled = true;
      var proto = ctor.prototype, originalUpdate = proto.updateQuantity, originalChange = proto.onChange;
      if (typeof originalUpdate !== 'function' || typeof originalChange !== 'function') return;
      nativeUpdate = originalUpdate;
      proto.updateQuantity = function (index, quantity, name, context, stamp) {
        var result = request(this, index, quantity, name, context, stamp);
        if (result) return result;
        trace('native-compatible-mode', { reason: 'missing-line-identity' });
        return originalUpdate.apply(this, arguments);
      };
      proto.onChange = function (event) {
        var dispatch = dispatches.get(event);
        if (dispatch && dispatch.handled) { trace('native-debounce-ignored', { connected: this.isConnected }); return; }
        if (!dispatch) {
          if (!this.isConnected || !event.target.isConnected) return;
          dispatch = { stamp: window.performance.now(), handled: false };
          dispatches.set(event, dispatch);
        }
        dispatch.handled = true;
        var target = event.target, previous = rowLine(this, target.dataset.index, target);
        if (!previous) return originalChange.call(this, event);
        return this.updateQuantity(target.dataset.index, target.value, target.name, previous, dispatch.stamp);
      };
      // Shrine QuantityInput reuses one Event object across clicks. Stamp each
      // dispatch, not the object's creation time, while retaining target validators.
      document.addEventListener('change', function (event) {
        var target = event.target;
        if (target.matches && target.matches('.quantity__input') && target.closest('cart-drawer-items')) {
          dispatches.set(event, { stamp: window.performance.now(), handled: false });
        }
      }, true);
      // The private 300ms callback sees an already handled dispatch and cannot
      // issue a second save after a drawer replacement.
      document.addEventListener('change', function (event) {
        var target = event.target;
        if (!target.matches || !target.matches('.quantity__input')) return;
        var component = target.closest('cart-drawer-items');
        if (component) component.onChange(event);
      });
      window.GBCart.subscribe(paintPending);
    }
    document.addEventListener('gb:cart-ready', ready, { once: true });
    if (window.customElements) window.customElements.whenDefined('cart-drawer-items').then(ready);
    ready();
  }
  return { buildId: 'gb-cart-quantity-3', identity: identity, locate: locate, plan: plan, install: install };
});
